import { render } from "./ContentLayout.vue?vue&type=template&id=ebbca664"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"
script.render = render

export default script